// web-ctr/src/components/ui/StatusPill.jsx
// The five roster status voices plus grey/undetermined (Dashboard.dc.html).
// Colour never carries the meaning without a word beside it (David's roster
// rule): children are the word and are required; an empty pill throws in dev
// so the mistake cannot ship silently.
const STATUSES = {
  cleared: 'bg-ok-bg text-ok-fg',
  expiring: 'bg-warn-bg text-warn-fg',
  gap: 'bg-bad-bg text-bad-fg',
  below: 'bg-bad-bg text-bad-fg',
  outside: 'bg-outside-bg text-outside-fg',
  grey: 'bg-fill text-ink-dim',
};

export default function StatusPill({ status = 'grey', className = '', children }) {
  if (import.meta.env.DEV && (children === undefined || children === null || children === '')) {
    throw new Error('StatusPill requires a word: colour never carries the meaning alone');
  }
  const voice = STATUSES[status] || STATUSES.grey;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-pill px-2.5 py-0.5 text-[11px] font-semibold tracking-[0.02em] ${voice} ${className}`}>
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-pill bg-current" />
      {children}
    </span>
  );
}
